import { createContext } from 'react';

export const AppContext = createContext({
    userLookup: {},
    setUserLookup: (auth) => {} // placeholder
});